import React from 'react';
import {useSelector} from "react-redux";
import AdminAccessDenied from "../../system/components/admin-access-denied";
import {ADMIN_PERMISSIONS, hasAdminPermission} from "../../system/admin-access";

function Index() {
    const user = useSelector((state) => state.auth.user);
    if (!hasAdminPermission(user, ADMIN_PERMISSIONS.SETTINGS_ACCESS)) {
        return <AdminAccessDenied/>;
    }
    return (
        <div className="w-full h-full">
        </div>
    );
}

export default Index;
